import React from 'react'
import './CoperateContent.scss'

import coperatePic from '../../../assets/Pictures/Corperate.png'

export default function CoperateContent() {
  return (
    <div className='coperateContent'>
      <div className="container">
        <div className="row">
          <div className="right">
            <h1 className="coperateContentTitle">
              HAKKIMIZDA
            </h1>
            <h2 className="coperateContentSubtitle">
              Çelik Sanayi, İnşaat, geri dönüşüm ve atıklardan enerji santrali sektöründe faaliyet gösteren Mühendislik, Danışmanlık ve Uluslararası Ticaret şirketiyiz. Şirketlerimiz ağırlıklı olarak Türkiye ve Umman'da faaliyet göstermektedir. Vigor Global Enerji şirketi “VGE” İstanbul, Türkiye'de ve Global Enerji Yatırım şirketi “GEI” Muscat, Umman'da bulunmaktadır.
              <br />
              <br />
              Çelik sektöründe faaliyet gösteren şirketlerimiz Ortadoğu'nun en büyük çelik ürünleri üreticilerinden biri olan Kavir Çelik Kompleksi'nin Türkiye, Umman ve Afrika ülkelerindeki resmi temsilcisidir. filmaşin, çelik külçe ve inşaat demiri gibi yüksek kalitedeki özel kalite ve Avrupa sertifikalarına sahip Demir Çelik ürünlerinin ham madde olarak kullanılan çeşitli fabrikalara ihracatı için Türkiye, Umman ve diğer ülkelerin önde gelen imalat ve inşaat firmaları ile yakın işbirliği içinde çalışmaktayız.               <br />
              <br />
              {/* Global Enerji Yatırım şirketi, MSW tesisi, geri dönüşüm ve atıklardan enerji santrallerine sektöründe, Dordtech Circular Energy Solutions (bu sektörün önde gelen şirketlerinden biri) ile yakın işbirliği içinde çalışmaktadır. Kârlı teknolojiyle plastik atıkları yakıta, atıkları yanıcı gazlara dönüştürerek atıklardan çevresel açıdan sürdürülebilir enerji üretiyoruz.             */}
              </h2>
          </div>
          <div className="left">
            <img src={coperatePic} alt="coperatePic" />
          </div>
        </div>
      </div>
    </div>
  )
}
